import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractButtonComponent } from '@shared/modules/buttons/components/abstracts/abstract-button.component';
import { ButtonService } from '@shared/modules/buttons/services/button.service';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['../abstracts/abstract-button.component.scss']
})
export class ButtonComponent extends AbstractButtonComponent {
  @Input() instanceId: string;
  @Input() isContentHidden: boolean = false;
  @Input() disabled: boolean = false;
  @Input() type: string = 'button';
  @Input() broadcast: boolean = false;
  @Input() loading: boolean;
  @Output() clicked: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  constructor(private btnService: ButtonService) {
    super();
  }

  onClick(event: MouseEvent): void {
    this.clicked.emit(event);

    if (this.broadcast) {
      this.btnService.onButtonClick(this.instanceId);
    }
  }
}
